<div style="width: 100%; display: inline-block; height: 215px; left: 70%; position: relative; ">
  <div style="float:left;height:215px " *ngIf="chartData?.departmentInfo">
    <div style=" width:50%; float:left; display:inline-grid; padding-top:50%; position:relative !important">
      <div *ngFor="let dept of chartData.departmentInfo" style="align-items:center; ">
        <span style="width:30px;display:inline-block"
              class="label label-success timesheet-status-{{dept.externalKey}}">
          <a class="timesheet-status-count"
             routerLink="/bu/{{selectedBusinessUnit.id}}/wrfid/{{dept.id}}" title="{{dept.inqueueCount}}">{{dept.inqueueCount}} </a>
        </span>
      </div>
    </div>
    <div style="width:50%; float:right;display:inline-grid; padding-top:50%; padding-left:25% ;position:relative !important">
      <div *ngFor="let dept of chartData.departmentInfo" style="text-align:left; text-transform: uppercase; color: #808080; ">
        {{dept.name}}
      </div>
    </div>
  </div>

</div>
